import styled from "styled-components";

// Container for the floating buttons
export const FloatButtonContainer = styled.div`
  position: fixed;
  top: 150px;
  right: 20px;
  padding: 5px;
   z-index: 9999;
  gap: 60px; /* Space between buttons */
 
`;

// Individual floating button
export const FloatButton = styled.button`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white; /* Blue color */
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
`;

// Icon inside the button
export const Icon = styled.div`
  color: green;
`; // Floating Buttons
// Drawer
export const Drawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background-color: #f8f9fa;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 20px;
  margintop: 100px;

  h4 {
    margin: 0;
  }

  button {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
  }
`;

export const SearchInput = styled.input`
  width: 50%;
  padding: 10px;
  margin-bottom: 20px;
  border: none;
  outline: none;
  border-radius: 5px;
`;

export const DrawerContent = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
`;

export const RowWrapper = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
`;

export const Column = styled.div`
  cursor: pointer;
`;

export const ColumnHeader = styled.div`
  font-weight: bold;
  font-size: 16px;
  color: #333;
  display: flex;
  justify: center;
`;

export const ColumnData = styled.div`
  margin-top: 10px;
  color: #555;

  div {
    margin-bottom: 5px;
  }
`;
